<template>
  <div>
    <b-form-row v-for="(field, key) in formSchema" :key="field.key">
      <b-col>
        <component
          :key="field.key"
          :is="field.component"
          v-bind="field.attrs"
          v-on="field.listeners"
          @input="handleInput($event, field.key, field.component)"
          v-model="form[field.key]"
          :id="field.key"
        />
      </b-col>
      <b-col cols="3" v-if="field.component === 'FormInput'">
        <b-form-group label="العملية" label-for="operator">
          <b-form-select
            @input="changeOperator($event, key)"
            selected="يحتوي على"
            v-model="selectedOperator[key]"
            :options="operatorOptions"
            id="operator"
          >
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import {
  BRow,
  BFormRow,
  BCol,
  BForm,
  BButton,
  BFormCheckbox,
  BFormSelect,
  BFormGroup,
} from "bootstrap-vue";
import FormInput from "@/components/form-input";
import FormTextarea from "@/components/form-textarea";
import FormSelect from "@/components/form-select";
import FormMultiDatepicker from "@/components/form-multi-datepicker";
import FormDatepicker from "@/components/form-datepicker";
import VSelect from "vue-select";
import FormMask from "@/components/form-mask/index.vue";
import FormAutocomplete from "@/components/form-autocomplete/index.vue";
import GeneratePassword from "@/components/generate-password/index.vue";
import { mapMutations } from "vuex";
import { rangeDateFormat } from "@/utils/utils";

export default {
  props: {
    formSchema: {
      type: Object,
      required: true,
    },
    value: Object,
  },

  components: {
    FormMultiDatepicker,
    FormInput,
    FormTextarea,
    FormSelect,
    BRow,
    BFormRow,
    BCol,
    BForm,
    BButton,
    FormDatepicker,
    VSelect,
    BFormCheckbox,
    FormMask,
    FormAutocomplete,
    GeneratePassword,
    BFormSelect,
    BFormGroup,
  },
  data() {
    return {
      selectedOperator: {},
      operatorOptions: ["يحتوي على", "مطابق لـ", "يبدأ بـ", "ينتهي بـ"],
      lastVal: "",
    };
  },
  computed: {
    form: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },

  methods: {
    ...mapMutations("AdvancedReports", [
      "setQueryFilters",
      "unsetQueryFilters",
    ]),
    mapInputOperator(value, operator) {
      switch (operator) {
        case "يحتوي على":
          return `%${value}%`;
        case "يبدأ بـ":
          return `${value}%`;
        case "ينتهي بـ":
          return `%${value}`;
        case "مطابق لـ":
          return `${value}`;
        default:
          return `%${value}%`;
      }
    },
    changeOperator(e, key) {
      if (this.form[key]) {
        this.setQueryFilters({
          path: key,
          value: this.mapInputOperator(this.form[key], e),
        });
      }
    },
    handleInput(e, key, component) {
      const re = new RegExp(
        "^[0-9]{4}-[0-9]{1,2}-[0-9]{1,2} إلى [0-9]{4}-[0-9]{1,2}-[0-9]{1,2}$"
      );
      if ((e && Array.isArray(e) && e.length > 0) || (e && !Array.isArray(e))) {
        if (component === "FormInput")
          this.setQueryFilters({
            path: key,
            value: this.mapInputOperator(e, this.selectedOperator[key]),
          });
        else if (component === "FormMultiDatepicker")
          this.setQueryFilters({
            path: key,
            value: {
              start: rangeDateFormat(e)[0],
              end: rangeDateFormat(e)[1],
            },
          });
        else
          this.setQueryFilters({
            path: key,
            value: e,
          });
      } else {
        this.unsetQueryFilters({
          path: key.slice(0, key.lastIndexOf(".")),
          key: key.slice(key.lastIndexOf(".") + 1),
        });
      }
    },
    clearOperators() {
      this.selectedOperator = {};
    },
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
  },
};
</script>
